import M1 from "resources/M1.png"
import M2 from "resources/M2.png"
import M3 from "resources/M3.png"
import M4 from "resources/M4.png"
import M5 from "resources/M5.png"
import L1 from "resources/L1.png"
import L2 from "resources/L2.png"
import L3 from "resources/L3.png"
import L4 from "resources/L4.png"
import L5 from "resources/L5.png"
import S from "resources/S.png"

import blurredM1 from "resources/blur/M1.png"
import blurredM2 from "resources/blur/M2.png"
import blurredM3 from "resources/blur/M3.png"
import blurredM4 from "resources/blur/M4.png"
import blurredM5 from "resources/blur/M5.png"
import blurredL1 from "resources/blur/L1.png"
import blurredL2 from "resources/blur/L2.png"
import blurredL3 from "resources/blur/L3.png"
import blurredL4 from "resources/blur/L4.png"
import blurredL5 from "resources/blur/L5.png"
import blurredS from "resources/blur/S.png"

export const reels = [
  [
    "M2",
    "M5",
    "L3",
    "L5",
    "M1",
    "M3",
    "L4",
    "L1",
    "M2",
    "M4",
    "L3",
    "L2",
    "L1",
    "M3",
    "M2",
    "L3",
    "M1",
    "L4",
    "M4",
    "M2",
    "L3",
    "M1",
    "L5",
    "L4",
    "M2",
    "L3",
    "M3",
    "M1",
    "L1",
    "M2",
    "L4",
    "M5",
    "L5",
    "L3",
    "L2",
    "L4",
    "M3",
    "M1",
    "L5",
    "L2",
    "L1",
    "M5",
    "M2",
    "M4",
    "L2",
    "M1",
    "M5",
    "L1",
    "L4",
    "L2",
    "M1",
    "M5",
    "L5",
    "S",
    "M4",
    "L1",
    "M1",
    "L5",
    "M5",
    "L2",
    "L1",
    "L4",
    "M1",
    "L3",
    "L5",
    "L2",
  ],
  [
    "M1",
    "L1",
    "M2",
    "M3",
    "L2",
    "M4",
    "L1",
    "M1",
    "M5",
    "L2",
    "M2",
    "L5",
    "L3",
    "M1",
    "L2",
    "L4",
    "L5",
    "M5",
    "L1",
    "M3",
    "L2",
    "M1",
    "L3",
    "L1",
    "L4",
    "M3",
    "M4",
    "L3",
    "M1",
    "L2",
    "L5",
    "L1",
    "M3",
    "M5",
    "L4",
    "L5",
    "S",
    "L1",
    "M5",
    "M2",
    "L2",
    "L3",
    "M1",
    "L4",
    "L1",
    "M4",
    "L3",
    "L2",
    "M5",
    "L1",
    "L5",
    "L3",
    "L2",
    "L4",
    "L1",
    "L5",
    "L3",
    "L2",
    "M1",
    "L1",
    "L4",
    "L3",
    "L2",
    "M1",
    "L5",
    "L4",
    "M5",
    "L2",
  ],
  [
    "M3",
    "M1",
    "L1",
    "M4",
    "L4",
    "L5",
    "M5",
    "M1",
    "M3",
    "M4",
    "L5",
    "M5",
    "L4",
    "M3",
    "L3",
    "M4",
    "L1",
    "L5",
    "M5",
    "L3",
    "L4",
    "M2",
    "L5",
    "M3",
    "L3",
    "L4",
    "M5",
    "L2",
    "M2",
    "M4",
    "M3",
    "L3",
    "L1",
    "L5",
    "L4",
    "M4",
    "M2",
    "M5",
    "L2",
    "L4",
    "L3",
    "M2",
    "L1",
    "M4",
    "M3",
    "M1",
    "S",
    "L1",
    "L2",
    "M5",
    "M3",
    "L5",
    "L1",
    "L2",
    "L3",
    "L4",
    "L5",
    "M1",
    "L2",
    "L1",
    "M4",
    "L5",
    "M5",
    "L2",
    "L3",
    "L4",
  ],
  [
    "M3",
    "M1",
    "M2",
    "L5",
    "L1",
    "M3",
    "M4",
    "M2",
    "L2",
    "L1",
    "M3",
    "L5",
    "L4",
    "M4",
    "M2",
    "M1",
    "M3",
    "L3",
    "L2",
    "L5",
    "M5",
    "M2",
    "L1",
    "L4",
    "L2",
    "L5",
    "M3",
    "L1",
    "M5",
    "L2",
    "L5",
    "M3",
    "L1",
    "M1",
    "L2",
    "L5",
    "L3",
    "S",
    "M3",
    "L1",
    "L5",
    "L3",
    "M2",
    "L2",
    "M1",
    "M5",
    "L3",
    "L5",
    "L1",
    "L2",
    "M2",
    "L3",
    "L4",
    "L5",
    "L1",
    "M5",
    "M2",
    "L2",
    "L5",
    "M1",
    "M5",
    "M4",
    "M2",
    "L4",
    "L5",
    "L3",
    "M5",
  ],
  [
    "M4",
    "M5",
    "M3",
    "L1",
    "L4",
    "M4",
    "L3",
    "L2",
    "L1",
    "L5",
    "M4",
    "L3",
    "M5",
    "L1",
    "L2",
    "M4",
    "L5",
    "S",
    "L4",
    "L1",
    "M4",
    "L5",
    "L2",
    "M1",
    "M2",
    "L1",
    "L5",
    "M5",
    "L2",
    "M2",
    "L3",
    "M4",
    "M5",
    "L2",
    "M1",
    "M2",
    "L4",
    "M5",
    "S",
    "M3",
    "M2",
    "L4",
    "M5",
    "L1",
    "L3",
    "M2",
    "L5",
    "M5",
    "M3",
    "L4",
    "L3",
    "L5",
    "M1",
    "L1",
    "L4",
    "M4",
    "M5",
    "L2",
    "L3",
    "L4",
    "L5",
    "M2",
  ],
]

export const icons = {
  M1,
  M2,
  M3,
  M4,
  M5,
  L1,
  L2,
  L3,
  L4,
  L5,
  S,
}

export const blurredIcons = {
  M1: blurredM1,
  M2: blurredM2,
  M3: blurredM3,
  M4: blurredM4,
  M5: blurredM5,
  L1: blurredL1,
  L2: blurredL2,
  L3: blurredL3,
  L4: blurredL4,
  L5: blurredL5,
  S: blurredS,
}

export const lines = [
  [], // 0
  [1, 1, 1, 1, 1], // 1
  [0, 0, 0, 0, 0], // 2
  [2, 2, 2, 2, 2], // 3
  [0, 1, 2, 1, 0], // 4
  [2, 1, 0, 1, 2], // 5
  [0, 0, 1, 2, 2], // 6
  [2, 2, 1, 0, 0], // 7
  [1, 0, 1, 2, 1], // 8
  [1, 2, 1, 0, 1], // 9
  [0, 1, 1, 1, 2], // 10
  [2, 1, 1, 1, 0], // 11
  [1, 0, 0, 1, 2], // 12
  [1, 2, 2, 1, 0], // 13
  [1, 1, 0, 1, 2], // 14
  [1, 1, 2, 1, 0], // 15
  [0, 0, 1, 2, 1], // 16
  [2, 2, 1, 0, 1], // 17
  [1, 0, 1, 2, 2], // 18
  [1, 2, 1, 0, 0], // 19
  [0, 0, 0, 1, 2], // 20
]

export const spritesheets = [
  "M3-spritesheet.json",
  "M5-spritesheet.json",
  "anticipation-spritesheet.json",
]
